import type { TaskPageResponse } from '@erp/rpc';
import { PageIcon } from 'src/components/task-pages/taskPageIcons';

export function TaskPageHeading({ page }: { page: TaskPageResponse }) {
  return (
    <>
      <PageIcon iconKey={page.icon} className="size-4 text-stone-600" />
      <h1 className="text-sm font-semibold text-stone-900">{page.name}</h1>
      {page.description && (
        <span className="max-w-96 truncate text-xs text-muted-foreground">
          {page.description}
        </span>
      )}
    </>
  );
}
